/**
 * Every back-office report row carries its own `currency` — unlike the
 * customer app's useCurrency() hook (one currency per active group), this
 * surface aggregates across groups/currencies, so amounts are always
 * formatted with the row's own code, never a store-wide default.
 */
export function formatCurrencyAmount(amountMinorUnits: number, currencyCode: string): string {
  // Whole amounts (every report row) stay unrounded and undecorated. Fractional
  // ones keep two places: a per-user tier rate of 0.3 would otherwise print as
  // "$0", which reads as a free plan.
  const isWhole = Number.isInteger(amountMinorUnits);

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: isWhole ? 0 : 2,
  }).format(amountMinorUnits);
}
